import { render } from "./Login.vue?vue&type=template&id=8810ec38&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=8810ec38&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2135/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8810ec38"]])

export default __exports__